import { render, staticRenderFns } from "./CharacterAddingDialog.vue?vue&type=template&id=d77b4e64&lang=pug&"
import script from "./CharacterAddingDialog.vue?vue&type=script&lang=js&"
export * from "./CharacterAddingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterAddingDialog.vue"
export default component.exports